import { render, staticRenderFns } from "./FormAssignFleets.vue?vue&type=template&id=10a221ca&scoped=true"
import script from "./FormAssignFleets.vue?vue&type=script&lang=js"
export * from "./FormAssignFleets.vue?vue&type=script&lang=js"
import style0 from "./FormAssignFleets.vue?vue&type=style&index=0&id=10a221ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a221ca",
  null
  
)

export default component.exports